const AppStyles = {
    colors: {
      COLOR_RED: "#C70000",
      COLOR_WHITE: "#FFFFFF",
      COLOR_BLACK: "#111111",
      COLOR_GREY9: "#999999",
      COLOR_GREY6: "#666666",
      COLOR_GREY3: "#333333",
      COLOR_ORANGE: "#F66700",
      COLOR_GREYE6: "#E6E6E6",
      COLOR_ORANGE2: "#FF6B00",
      GREY_F7F6F5: "#F7F6F5",
      PLACEHOLDER_COLOR: "#FFFFFFB2",
      COLOR_ORANGE3: "#ff6b001a",
      COLOR_BLUE1: "#0058B7",
      COLOR_BLUE2: "#0066ba1a",
      COLOR_GREEN1: "#006661",
      COLOR_GREEN2: "#0066611a",
      COLOR_VIOLET1: "#9054A1",
      COLOR_VIOLET2: "#9054a11a",
      COLOR_GREY8: "#f7f6f5",
      COLOR_GREY10: "#0000001a",
      COLOR_GREY666: "#e6e6e666",
      COLOR_GREYD7: "#D7D7D7",
      COLOR_GREYB3: "#000000b3",
      COLOR_REDC7: "#C75300",
      COLOR_GREY85: "#858585",
      COLOR_LIGHTORANGE: "#FFDCC1",
    },
  };
  export default AppStyles;
  